import { render } from "./areaDocumentos.vue?vue&type=template&id=72488b36&scoped=true"
import script from "./areaDocumentos.vue?vue&type=script&lang=js"
export * from "./areaDocumentos.vue?vue&type=script&lang=js"

import "./areaDocumentos.vue?vue&type=style&index=0&id=72488b36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72488b36"]])

export default __exports__